import React, { FC, useMemo } from 'react'
import { Props as ReactSelectProps } from 'react-select'

export type SelectProps = {
  className?: string
  options: { value: string; label: string }[]
  value: string
  onChange: ReactSelectProps['onChange']
}

import { colors } from '../../theme'

import * as SC from './styled'

const ActionButton: FC<SelectProps> = ({ className, options, value, onChange }) => {
  const selectedOption = useMemo(() => options.find((option) => option.value === value), [
    options,
    value,
  ])

  const customStyles = useMemo<ReactSelectProps['styles']>(
    () => ({
      control: (provided) => ({
        ...provided,
        border: 'none',
        boxShadow: 'none',
        cursor: 'pointer',
      }),
      indicatorSeparator: () => ({
        display: 'none',
      }),
      valueContainer: (provided) => ({
        ...provided,
        justifyContent: 'flex-end',
      }),
      singleValue: (provided) => ({
        ...provided,
        top: '60%',
      }),
      menu: (provided) => ({
        ...provided,
        margin: 0,
      }),
      menuList: (provided) => ({
        ...provided,
        padding: 0,
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? colors.pureBlack : colors.pureWhite,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: colors.lightGrey,
        },
      }),
    }),
    []
  )

  return (
    <SC.Select
      className={className}
      options={options}
      isSearchable={false}
      value={selectedOption}
      onChange={onChange}
      hideSelectedOptions
      styles={customStyles}
    />
  )
}

export default ActionButton
